import { styled } from '@linaria/react';
import {
  bodyFont,
  fonts,
  layout,
  primitives,
  semantic,
  shadow,
  size,
  space,
} from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  z-index: 1;

  &[data-open='true'] {
    z-index: ${layout.zIndexDropdown};
  }
`;

export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-100']};
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  height: ${primitives.size['size-1200']};
  padding: ${space['space-300']};
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.surfaceSubtle};
  color: ${semantic.text.primary};
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceDefault};
  }

  &[data-active='true'] {
    background: ${semantic.bg.primary};
    color: ${semantic.text.inverse};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-300']} ${space['space-500']};
  }
`;

export const TriggerLabel = styled.span`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: inline;
  }
`;

export const Panel = styled.ul`
  position: absolute;
  top: calc(100% + ${space['space-200']});
  right: 0;
  box-sizing: border-box;
  margin: 0;
  padding: ${space['space-400']} 0;
  list-style: none;
  background: ${semantic.bg.canvas};
  border-radius: ${size.radius['radius-xxl']};
  box-shadow: ${shadow.lg};
  white-space: nowrap;
  min-width: 180px;

  &[data-align='left'] {
    right: auto;
    left: 0;
  }
`;

export const PanelOption = styled.li`
  display: flex;
  align-items: center;
  min-height: ${primitives.size['size-1200']};
  padding: 0 ${space['space-600']};

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  label {
    width: 100%;
    gap: ${space['space-300']};
    font-size: ${fonts.size.base};
  }
`;
